const PERMISSION_KEY= "core:user_referral";
const PAGE_URL = {
    USER_REFERRAL_PAGE: "/admin/core/user-referral"
}

export {PERMISSION_KEY, PAGE_URL}

